<template>
  <!--   <div class="menu">
    <div class="orderid-container">
      <div class="orderid-title">Order Placed</div>
      <div class="orderid-body">
        <span class="orderid-pretext">Your Order Id is</span>
        <span class="orderid-id">#{{ this.orderID }}</span>
      </div>
      <div class="contact-wrapper">
        <span class="orderid-pretext">
          You will get a confirmation call soon.
        </span>
        <div class="number-wrapper">
          For enquiries:

          <a v-if="this.locationID === 1" href="tel:9801225225"
            >Call us at 9801225225</a
          >

          <a v-if="this.locationID === 2" href="tel:9802838383"
            >Call us at 9802838383</a
          >
        </div>
      </div>
    </div>
    
  </div> -->

  <div class="order-placed">
    <p class="heading">Your Order Has Been Placed</p>
    <p>
      Your Order Id is <span class="id">#{{ this.orderID }}</span>
    </p>

    <div v-show="this.payMode !== 3 && this.payMode !== 5">
      <a-button class="paynow-button" @click="makePayment"> Pay Now </a-button>
    </div>

    <br />
    <p>
      You will get a confirmation call soon. <br />
      <span
        >For enquires:
        <span class="number">Call us at +977-015970770 (Kathmandu)</span>
        <span class="number"
          >Call us at +977-015970880/9802838383 (Pokhara)</span
        >
      </span>
    </p>
  </div>
</template>

<script>
// @ is an alias to /src\

import { CartData, LocationId } from "../../services/storage.service";
import router from "../../router";
import { mapGetters } from "vuex";

export default {
  name: "OrderStatus",
  data() {
    return {
      orderID: CartData.getOrderId(),
      locationID: LocationId.getLocationId(),
    };
  },
  created() {
    window.scrollTo(0, 0);
  },

  computed: {
    ...mapGetters(["payMode"]),
  },

  methods: {
    makePayment() {
      router.replace("/p/paymentmethod");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

// new css
// variables
$theme-color: #ed3c3b;
$font-color: #706b6b;
$detail-color: #333;
$success-color: #60b246;
$info-color: #2e89d3;

$button-size: 16px;
$text-size: 16px;
$icon-size: 20px;
$heading-size: 24px;
$display-size: 36px;

$border: 1px solid rgba(3, 3, 3, 0.3);
$border-radius: 10px;

.order-placed {
  border: $border;
  border-radius: $border-radius;
  width: 50%;
  margin: 100px auto 0;
  padding: 30px;
  margin-bottom: 6%;
  text-align: center;
  .heading {
    font-size: $heading-size;
    font-weight: bolder;
    color: $success-color;
  }
  p {
    font-size: $text-size;
    &:nth-child(2) {
      margin: 30px 0;
    }

    span {
      font-size: 14px;
    }
    .id {
      font-weight: bold;
      color: $theme-color;
      font-size: $heading-size;
    }
    .number {
      color: $theme-color;
    }
  }
}

.paynow-button {
  width: 150px;
  padding: 10px;
  background-color: #60b246;
  color: white;
  height: auto;
  cursor: pointer;
  font-family: "Poppins", sans-serif;
  font-size: 16px;
  text-transform: uppercase;
  border-radius: 4px;
}

.paynow-button:hover {
  border-color: #60b246;
}

@media screen and (max-width: 768px) {
  .order-placed {
    width: 80%;
  }
}

@media screen and (max-width: 567px) {
  .order-placed {
    width: 85%;
  }
}

// old css
.custom-button-wrap {
  display: flex;
  justify-content: space-evenly;
  flex-direction: column;
  align-items: center;
  margin: 5px;
  height: auto;

  .custom-button {
    height: 50px;
    width: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin: 5px;

    &.green {
      background: #60b246;
      border-color: #60b246;
      &:hover {
        color: white;
      }
    }
    &.black {
      background: white;
      color: black;
      border-color: #60b246;
    }
    &.hide {
      display: none;
    }
  }
}

.loading {
  font-size: 18px;
  text-align: center;
  color: red;
  font-family: $main-font;
  margin-top: 30px;
}

.orderid-container {
  margin-top: 110px;
  font-family: $main-font;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-self: center;
  background-color: #f2f2f2;
}

.orderid-title {
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  color: #60b246;
}

.orderid-body {
  margin: 20px 10px;
}

.orderid-pretext {
  font-size: 20px;
}

.number-wrapper {
  font-size: 16px;
}

.orderid-id {
  font-size: 22px;
  font-weight: 600;
  color: $brand-color;
  padding-left: 5px;
}

.contact-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
